import {
  GetContactsBlock,
  UploadDataBlock,
  StartAnalyzeAllBlock,
} from "../../components/products";
import { TargetedAccountPlansBlock } from "../../components/products/TargetedAccountPlansBlock";

export const ActionBlock = ({
  campaign_id,
  totalAccounts,
  hasContacts,
  canAnalyzeAll,
  showTargetAccountPlansBlock,
}: {
  campaign_id: string;
  totalAccounts: number;
  hasContacts: boolean;
  canAnalyzeAll: boolean;
  showTargetAccountPlansBlock: boolean;
}) => {
  if (totalAccounts === 0) return <UploadDataBlock campaign_id={campaign_id} />;

  if (!hasContacts) return <GetContactsBlock campaign_id={campaign_id} />;

  if (canAnalyzeAll) return <StartAnalyzeAllBlock campaign_id={campaign_id} />;

  // if (showTargetAccountPlansBlock)
  //   return <TargetedAccountPlansBlock campaign_id={campaign_id} />;

  return null;
};
